export enum ModelType {
  LLM = 'LLM',
  TTS = 'TTS',
  STT = 'STT',
}

export const modelTypesOptions: { value: ModelType; label: string }[] = [
  { value: ModelType.LLM, label: 'LLM' },
  { value: ModelType.TTS, label: 'TTS' },
  { value: ModelType.STT, label: 'STT' },
];
